export interface Common {

}

export enum StockTypes {
    ALL,
    FOS,
    ETHICAL,
    DISCOUNTABLE,
    NON_DISCOUNTABLE,
    ZFREEDOM,
    NON_ZFREEDOM,
    STORED_IN_ROBOT,
    NOT_STORED_IN_ROBOT,
    ROBOT_SOH_DIFF_SHOP_SOH,
    ONLINE,
    NOT_ONLINE
}

export enum StockStatuses {
    ALL,
    ACTIVE,
    INACTIVE
}

export enum StockOptions {
    ALL,
    AUTH_REQ_ON,
    AUTH_REQ_OFF,
    AUTO_ORDER_ON,
    AUTO_ORDER_OFF,
    CUST_DISPLAY_ON,
    CUST_DISPLAY_OFF,
    AUTO_PRINT_ON,
    AUTO_PRINT_OFF
}

export enum StockRangeFilterType {
    RETAIL_SELL_PRICE,
    GST_AMOUNT,
    COST_EX,
    LAST_INV_COST_EX,
    PREV_INV_COST_EX,
    AVG_COST_EX,
    LIST1_Price_EX,
    MARK_UP,
    SOH,
    PACK_SIZE,
    MIN_STOCK_LEV,
    MAX_STOCK_LEV,
    MIN_ORD_QTY,
    SOH_COMPARED_AVG_SALES,
    SOH_COMPARED_AVG_SALES_PERCENT,
    LAST_PURCHASED,
    LAST_SOLD,
    DATE_CREATED,
    QTY_ON_ORD,
    LAST_STOCKTAKED,
    ROBOT_SOH,
    SOH_END
}

export enum AdvancedStockRangeFilterType {
    UNITS_SOLD,
    UNITS_SOLD_OTC,
    UNITS_SOLD_SCRIPTS,
    SALES_VALUE,
    SALES_VALUE_OTC,
    SALES_VALUE_SCRIPTS,
    GP,
    GP_OTC,
    GP_SCRIPTS,
    UNITS_PURCHASED
}

export enum ClientRangeFilterType {
    HOME_POSTCODE,
    POSTAL_POSTCODE,
    AGE,
    DATE_CREATED,
    DOB_DAY,
    DOB_MONTH,
    DOB_YEAR,
    DOB,
    CLUB_MEMBERSHIP_EXPIRY,
    CLUB_POINTS,
    CLUB_DOLLARS
}

export enum ReceiptItemRangeFilterType {
    RECEIPT_NO,
    STOCK_COST,
    STOCK_AVG_COST,
    SELL_PRICE,
    SELL_PRICE_GST,
    DISCOUNT,
    PROMO_DISCOUNT,
    SURCHARGE,
    SUB_TOTAL,
    SUB_TOTAL_GST,
    GOVT_CONT,
    QTY,
    VALUE,
    VALUE_EX,
    COGS,
    GP,
    MARKUP,
    MARGIN,
    PAYMENT_SURCHARGE,
    AGENCY_COMMISSION,
    TOTAL_DISCOUNT,
    RECEIPT_DISCOUNT,
    RECEIPT_PROMO_DISCOUNT,
    RECEIPT_SURCHARGE,
    RECEIPT_SUB_TOTAL,
    RECEIPT_SUB_TOTAL_GST,
    RECEIPT_GOVT_CONT,
    RECEIPT_QTY,
    RECEIPT_VALUE,
    RECEIPT_VALUE_EX,
    RECEIPT_COGS,
    RECEIPT_GP,
    RECEIPT_MARKUP,
    RECEIPT_MARGIN,
    RECEIPT_ITEMS,
    RECEIPT_PAYMENT_SURCHARGE,
    RECEIPT_AGENCY_COMMISSION
}

export enum DebtorTransactionRangeFilterType {
    AMOUNT,
    RUNNING_TOTAL
}

export enum AdvancedClientRangeFilterType {
    PURCHASED_ANY_OF,
    NOT_PURCHASED_ANY_OF,
    DISPENSED_ANY_OF,
    NOT_DISPENSED_ANY_OF,
    UNITS_PURCHASED,
    UNITS_PURCHASED_OTC,
    UNITS_PURCHASED_SCRIPTS,
    RECEIPTS_PURCHASED,
    RECEIPTS_PURCHASED_OTC,
    RECEIPTS_PURCHASED_SCRIPTS,
    SALES_VALUE,
    SALES_VALUE_OTC,
    SALES_VALUE_SCRIPTS,
    GP,
    GP_OTC,
    GP_SCRIPTS,
    NUMBER_SCRIPTS_DISPENSED,
    NUMBER_OWING_SCRIPTS,
    NUMBER_PRESCRIBERS,
    REPEATS_PRESCRIBED
}

export enum RangeFilterOperator {
    EQUAL,
    NOT_EQUAL,
    LESS_THAN,
    LESS_THAN_OR_EQUAL,
    GREATER_THAN,
    GREATER_THAN_OR_EQUAL,
    BETWEEN,
    NOT_BETWEEN,
    NONE
}

export enum ReferenceTimes {
    TODAY = 0,
    START_WEEK = 1,
    END_WEEK = 2,
    START_MONTH = 3,
    END_MONTH = 4,
    START_YEAR = 5,
    END_YEAR = 6,
    START_FY = 7,
    END_FY = 8
}

export enum TimeUnits {
    DAY = 0,
    WEEK = 1,
    MONTH = 2,
    YEAR = 3
}

export enum AndOrOperator {
    AND,
    OR
}

export enum RangeFilterUnitType {
    PERCENT,
    UNIT
}

export enum ActiveCostType {
    PREVIOUS,
    LAST,
    AVG,
    WS1
}

export enum StockLockdownField {
    StockGroup,
    Category,
    Name,
    MinOrdQty,
    Department
}

export interface StockFilterCriteria {
    searchString?: string;
    searchName?: boolean;
    searchPDE?: boolean;
    searchBarcode?: boolean;
    containsSearch?: boolean;
    departments?: string[];
    departmentsNotSet?: boolean;
    subDepartments?: string[];
    subDepartmentsNotSet?: boolean;
    suppliers?: string[];
    suppliersNotSet?: boolean;
    manufacturers?: string[];
    manufacturersNotSet?: boolean;
    stockGroups?: string[];
    locations?: string[];
    locationsNotSet?: boolean;
    categories?: string[];
    categoriesNotSet?: boolean;
    promotions?: string[];
    bonusPromotions?: string[];
    clubs?: string[];
    rangeFilters?: RangeFilter[];
    schedules?: string[];
    schedulesNotSet?: boolean;
    statuses?: StockStatuses[];
    types?: StockTypes[];
    options?: StockOptions[];
    advancedRangeFilters?: AdvancedStockRangeFilter[];
    stkIDs?: string[];
    gSTCodes?: string[];
}

export interface RangeFilter {
    type?: StockRangeFilterType | null;
    operators?: RangeFilterOperatorDescPair[];
    operator?: RangeFilterOperator | null;
    value1?: any | null;
    value2?: any | null;
    dateValue1?: string | null;
    dateValue2?: string | null;
}

export interface AdvancedStockRangeFilter {
    type?: AdvancedStockRangeFilterType | null;
    operators?: RangeFilterOperatorDescPair[];
    operator?: RangeFilterOperator | null;
    value1?: any | null;
    value2?: any | null;
    startDate?: string | null;
    endDate?: string | null;
    customerIDs?: string[];
    linesMatchingOperators?: RangeFilterOperatorDescPair[];
    linesMatchingOp?: RangeFilterOperator | null;
    linesMatchingVal1?: number | null;
    linesMatchingVal2?: number | null;
}

export interface StockRegisterFilterCriteria {
    searchString?: string;
    containsSearch?: boolean;
    searchName?: boolean;
    searchPDE?: boolean;
    searchAPN?: boolean;
    showInactive?: boolean;
    stkIDs?: string[];
}

export interface ReportColumn {
    type?: ReportColumnType | null;
    name?: string;
    customData?: string | null;
    customTotalType?: ReportColumnTotalType | null;
}

export enum DefaultDateFilter {
    TODAY,
    START_OF_WEEK,
    END_OF_WEEK,
    START_OF_MONTH,
    END_OF_MONTH,
    START_OF_YEAR,
    END_OF_YEAR,
    START_OF_FY,
    END_OF_FY
}

export enum DefaultDateFilterPeriod {
    DAYS,
    WEEKS,
    MONTHS,
    YEARS
}

export enum ReportColumnTotalType {
    SUM = 0,
    AVG_USING_TOTALS = 1,
    AVG = 2
}

export enum ReportColumnType {
    STOCK_NAME = 0,
    STOCK_SOH = 1,
    STOCK_WS1 = 2,
    STOCK_PREV_INV = 3,
    STOCK_LAST_INV = 4,
    STOCK_AVG_COST = 5,
    STOCK_COST = 6,
    STOCK_SELL_PRICE_EX = 7,
    STOCK_SELL_PRICE = 8,
    STOCK_GP = 9,
    STOCK_MARKUP = 10,
    STOCK_MARGIN = 11,
    STOCK_VALUE = 12,
    STOCK_CREATED = 13,
    STOCK_LAST_SOLD = 14,
    STOCK_LAST_PURCHASED = 15,
    STOCK_SCHEDULE = 16,
    STOCK_ACTIVE = 17,
    STOCK_PDE = 18,
    STOCK_APN = 19,
    STOCK_DEPT = 20,
    STOCK_SUB_DEPT = 21,
    STOCK_SUPPLIER = 22,
    STOCK_MANUFACTURER = 23,
    STOCK_SALES_TOTAL_EX = 24,
    STOCK_SALES_TOTAL = 25,
    STOCK_SALES_GP = 26,
    STOCK_SALES_MARKUP = 27,
    STOCK_SALES_MARGIN = 28,
    STOCK_QTY_SOLD = 29,
    STOCK_COGS = 30,
    STOCK_GROUPS = 31,
    STOCK_LOCATIONS = 32,
    STOCK_CATEGORIES = 33,
    STOCK_TURNOVER_RATE = 34,
    STOCK_AVG_SOH_VALUE = 35,
    STOCK_QTY_ON_ORDER = 36,
    STOCK_QTY_PURCHASED = 37,
    STOCK_SOH_END = 38,
    STOCK_WS1_END = 39,
    STOCK_PREV_INV_END = 40,
    STOCK_LAST_INV_END = 41,
    STOCK_AVG_COST_END = 42,
    STOCK_COST_END = 43,
    STOCK_SELL_PRICE_EX_END = 44,
    STOCK_SELL_PRICE_END = 45,
    STOCK_GP_END = 46,
    STOCK_MARKUP_END = 47,
    STOCK_MARGIN_END = 48,
    STOCK_VALUE_END = 49,
    STOCK_QTY_SOLD_TIME = 50,
    STOCK_QTY_PURCHASED_TIME = 51,
    STOCK_FULL_NAME = 52,
    STOCK_HEIGHT = 53,
    STOCK_LENGTH = 54,
    STOCK_WIDTH = 55,
    STOCK_WEIGHT = 56,
    STOCK_VOLUME = 57,
    STOCK_MAX_PER_CUSTOMER = 58,
    STOCK_ADD_DETAIL = 59,
    STOCK_PROMO_PRICE = 60,
    STOCK_PROMO_PRICE_END_DATE = 61,
    STOCK_CUSTOM = 199,
    CLIENT_SURNAME = 200,
    CLIENT_FIRSTNAME = 201,
    CLIENT_TITLE = 202,
    CLIENT_SEX = 203,
    CLIENT_DOB = 204,
    CLIENT_POST_ADD = 205,
    CLIENT_POST_SUBURB = 206,
    CLIENT_POST_STATE = 207,
    CLIENT_POST_POSTCODE = 208,
    CLIENT_HOME_ADD = 209,
    CLIENT_HOME_SUBURB = 210,
    CLIENT_HOME_STATE = 211,
    CLIENT_HOME_POSTCODE = 212,
    CLIENT_PHONE = 213,
    CLIENT_FAX = 214,
    CLIENT_MOBILE = 215,
    CLIENT_EMAIL = 216,
    CLIENT_MEDICARE = 217,
    CLIENT_MEDICARE_EXP = 218,
    CLIENT_CONCESSION = 219,
    CLIENT_CONCESSION_EXP = 220,
    CLIENT_SN_ENTITLEMENT = 221,
    CLIENT_REPAT_NO = 222,
    CLIENT_REPAT_TYPE = 223,
    CLIENT_REPAT_EXP = 224,
    CLIENT_FAMILY = 225,
    CLIENT_NURSING_HOME = 226,
    CLIENT_WARD = 227,
    CLIENT_ROOM_NO = 228,
    CLIENT_BED_NO = 229,
    CLIENT_OWING_SCRIPTS = 230,
    CLIENT_SALES_TOTAL_EX = 231,
    CLIENT_SALES_TOTAL = 232,
    CLIENT_SALES_GP = 233,
    CLIENT_SALES_MARKUP = 234,
    CLIENT_SALES_MARGIN = 235,
    CLIENT_QTY_SOLD = 236,
    CLIENT_COGS = 237,
    CLIENT_CUSTOM = 399,
    SALES_RECEIPT_NO = 400,
    SALES_DATE = 401,
    SALES_STAFF = 402,
    SALES_CUSTOMER = 403,
    SALES_ITEM_DESC = 404,
    SALES_ITEM_TYPE = 405,
    SALES_STOCK_NAME = 406,
    SALES_STOCK_COST = 407,
    SALES_STOCK_AVG_COST = 408,
    SALES_SELL_PRICE = 409,
    SALES_DISCOUNT = 410,
    SALES_PROMO_DISCOUNT = 411,
    SALES_PROMO_DESC = 412,
    SALES_SURCHARGE = 413,
    SALES_SUB_TOTAL = 414,
    SALES_SUB_TOTAL_GST = 415,
    SALES_GOV_CONT = 416,
    SALES_REGISTER = 417,
    SALES_DEPARTMENT = 418,
    SALES_AGENCY = 419,
    SALES_QTY = 420,
    SALES_VALUE = 421,
    SALES_VALUE_EX = 422,
    SALES_COGS = 423,
    SALES_GP = 424,
    SALES_MARKUP = 425,
    SALES_MARGIN = 426,
    HOUR = 427,
    HOUR_DISTINCT = 428,
    DAY = 429,
    DAY_DISTINCT = 430,
    MONTH = 431,
    MONTH_DISTINCT = 432,
    YEAR = 433,
    SALES_COMMENTS = 434,
    ITEM_COUNT = 435,
    SALES_PAYMENTS = 436,
    SALES_PAYMENTS_WITH_AMOUNTS = 437,
    SALES_PAY_METHOD_SURCHARGE = 438,
    SALES_AGENCY_COMMISSION = 439,
    SALES_STATUS = 440,
    SALES_PAYMENT_ACCOUNT = 441,
    SALES_RECEIPT_COUNT = 442,
    SALES_PRICE_CHANGE_REASON = 443,
    SALES_ORIGINAL_PRICE = 444,
    SALES_DISCOUNTED_PRICE = 445,
    SALES_TOTAL_DISCOUNT = 446,
    SALES_CUSTOM = 599,
    STOCK_ADJUSTMENTS_NAME = 600,
    STOCK_ADJUSTMENTS_REASON = 601,
    STOCK_ADJUSTMENTS_DATE = 602,
    STOCK_ADJUSTMENTS_QTY = 603,
    STOCK_ADJUSTMENTS_VALUE_LAST = 604,
    STOCK_ADJUSTMENTS_VALUE_AVG = 605,
    STOCK_ADJUSTMENTS_STAFF = 606,
    STOCK_ADJUSTMENTS_COST_LAST = 608,
    STOCK_ADJUSTMENTS_COST_AVG = 609,
    STOCK_AUDIT_DATE = 700,
    STOCK_AUDIT_USER = 701,
    STOCK_AUDIT_TYPE = 702,
    STOCK_AUDIT_NAME = 703,
    STOCK_AUDIT_SOH_OLD = 704,
    STOCK_AUDIT_SOH_NEW = 705,
    STOCK_AUDIT_SOH_DIFF = 706,
    STOCK_RRP = 707,
    STOCK_MOQ = 708,
    ROBOT_SOH = 709,
    CLUB_NAME = 800,
    CLUB_MEMBER_FIRSTNAME = 801,
    CLUB_MEMBER_SURNAME = 802,
    CLUB_CARD_NO = 803,
    CLUB_MEMBERSHIP_EXPIRY = 804,
    CLUB_MEMBERSHIP_CREATED = 805,
    CLUB_MODE = 806,
    CLUB_PTS_BALANCE = 807,
    CLUB_PTS_USED = 808,
    CLUB_PTS_EARNED = 809,
    CLUB_DOL_BALANCE = 810,
    CLUB_DOL_USED = 811,
    CLUB_DOL_EARNED = 812
}

export enum ReportTimePeriodTypes {
    MONTH = 0,
    MONTH_OF_YEAR = 1,
    DAY_OF_WEEK = 2
}

export interface Lists {
    rEG_MESSAGE_TYPE_ATTENTION?: string;
    rEG_MESSAGE_TYPE_EVENT?: string;
    rEG_MESSAGE_TYPE_ANNOUNCEMENT?: string;
    rEG_MESSAGE_TYPE_GENERAL?: string;
    rEG_MESSAGE_TYPE_TODO?: string;
}

export interface RangeFilterOperatorDescPair {
    operator?: RangeFilterOperator | null;
    description?: string;
}